export function debugLog(msg) {
  return; // comment out to activate debug logs
  console.log(msg);
}
